<template>
  <div class="text-center">
    <v-dialog
      v-model="show"
      width="500"
    >
      <v-card>
        <v-card-title class="headline lighten-2">
          Подтверждение платежа
        </v-card-title>

        <v-card-text>
          <p class="font">Сумма: {{ getCurrentPayout.sum }} &#8381;</p>
          <p class="font">ФИО: {{ getCurrentPayout.client_name }}</p>
          <p class="font">ИНН: {{ getCurrentPayout.inn }}</p>
          <p v-if="getCurrentPayout.ogrn" class="font">ОГРН: {{ getCurrentPayout.ogrn }}</p>
          <p class="font">Дата: {{ new Date(getCurrentPayout.dadd).toLocaleDateString() }}</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions v-if="canSeePayouts">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="toggle(getCurrentPayout.id, false)"
          >
            Отклонить
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="toggle(getCurrentPayout.id, true)"
          >
            Утвердить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";

export default {
  methods: {
    ...mapMutations("payouts", ["setShowModal"]),
    ...mapActions("payouts", ["setConclusion"]),

    async toggle(id, result) {
      await this.setConclusion({id, result});
      this.setShowModal();
    },
  },
  computed: {
    ...mapState("payouts", ["showModal"]),
    ...mapGetters("profile", ["canSeePayouts"]),
    ...mapGetters("payouts", ["getCurrentPayout"]),

    show: {
      get() {
        return this.showModal;
      },
      set() {
        this.setShowModal();
      }
    }
  }
}
</script>